import TrackPlugin from "./TrackPlugin";
import loadSegmentSDK, {formatTrackDataToSegmentSDKArguments} from "./SegmentSDK";
import {asyncCall, getExtendData, getGroupTraits, getIdentityTraits, pingCheck} from "../util";
import {xhrLogIgnoreReg} from "../consts";
import brototype from 'brototype';
const Bro = brototype;

export default class SegmentTrackPlugin extends TrackPlugin {
	constructor(API_KEY) {
		super('Segment');
		this.API_KEY = API_KEY;

		TrackPlugin.Raven.setBreadcrumbCallback(function(crumb) {
			// segment.io自己的请求跳过
			if (crumb.type === 'http' && xhrLogIgnoreReg.test(Bro(crumb).iCanHaz('data.url') || '')) {
				return false;
			}
			return crumb;
		})

		asyncCall(() => pingCheck())
	}

	async init() {
		if(!this.allowInit) {
			return
		}
		await loadSegmentSDK(this.API_KEY)
		let extedData = getExtendData() || {};
		let analytics = window.analytics;

		// jqj说可以放开
		// 又不可以了
		// 2022-10-19 又要放开了 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=132649285
		// if(!extedData.company_id_cipher) {
		// 	console.log('User without company_id_cipher, ignore');
		// 	return
		// }

		if(extedData.account_id_cipher){
			analytics.identify(extedData.account_id_cipher, getIdentityTraits());
		}else if(extedData.company_id_cipher) {
			// 没accountId，但是有company，记录为CID_{CompanyId}
			analytics.identify(`CID_${extedData.company_id_cipher}`, getIdentityTraits());
		}

		if(extedData.company_id_cipher){
			analytics.group(extedData.company_id_cipher, getGroupTraits());
		}

		analytics.page();
		super.init();
	}

	beforeTrackFilter(trackData) {
		return String(trackData.action).indexOf('c_') !== 0;
	}
	sendTrack(trackData) {
		const callArgs = formatTrackDataToSegmentSDKArguments(trackData);
		if(callArgs && window.analytics && typeof window.analytics.track === 'function'){
			window.analytics.track(...callArgs);
		}
	}
}
